import React from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import styleFile from './SummaryBanner.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { RichText } from '@synergycms_core/components/generic';
import { compose } from 'ramda';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { connect } from 'react-redux';
import { getSTPoints } from '../../../../store/customer/loyaltyUtils.js';

const STSummaryBanner = props => {
  const { theme, content } = props;
  const { classes } = theme.styles;
  const { tier, advantages,isLoyaltyReservation,accumulatedPoints } = props.config;
  let tierStarTraveleColor = '';
  if (tier === 'blue') {
    tierStarTraveleColor = classes.blueTierColor
  } else if (tier === 'silver'){
    tierStarTraveleColor = classes.silverTierColor
  }



  //const lowerTier = tier && toLower(tier);
  //tier can be: blue, silver or gold
  const tierName = content.t(`_%${tier}%_`);
  

  return isLoyaltyReservation && (
    <div className={[classes.starAccumPointsContainer, tierStarTraveleColor].join(' ')}>
      <div className={[classes.starAccumTextContainer, tierStarTraveleColor].join(' ')}>
        <div className={[classes.textwrapper]}>
          <RichText
            text={'_%como miembro Star Traveler acumularás%_'}
            translate={true}
            ucFirst={true}
          />
        </div>
        <RichText
          translate={true}
          text={'_%{puntos} puntos!%_'}
          ucFirst={false}
          innerStyle={[classes.accumulatedPoints, tierStarTraveleColor].join(' ')}
          withVars={{
            puntos: accumulatedPoints
          }}
        />{" "}
        <RichText
          text={'_%con esta reserva%_'}
          translate={true}
          ucFirst={false}
        />
      </div>
      <RichText
        text={'_%ventajas exclusivas star traveler {tierName}%_'}
        translate={true}
        ucFirst={false}
        innerStyle={[classes.starAdvantagesTitle, tierStarTraveleColor].join(' ')}
        withVars={{
          tierName: tierName
        }}
      />
      <div className={classes.starAdvantagesContainer}>
        {
          advantages && advantages.get("advantages").map((advtage, idx)=>{
            const benefitIconSyn = advtage.get("icon") ? process.env.URL_ENVIRONMENT + '/api/medias/' + advtage.get("icon") : false;

            return (
              <RichText
              key={advtage + idx}
              innerStyle={[classes.amenity, 'roboto14BlackBold']}
              text={advtage.get("title")}
              ucFirst={true}
              translate={true}
              icon={
                benefitIconSyn ?
                  {
                    innerStyle: [classes.advantageIcon, tierStarTraveleColor].join(' '),
                    remoteSvg: true,
                    svg: benefitIconSyn,
                  } : ''
              }
            />
            );
          })
        }
      </div>
    </div>
  );
};

const mapStateToProps = (store, ownProps) => {
  const loyalty = store.getIn(["customer", "loyalty", "data", "loyalty"]);
  const baseTier = loyalty && loyalty.getIn(["tier"]);
  const tierList = store.getIn(["customer", "loyalty", "data", "tiers"]);
  const currentTier = loyalty && store.getIn(['customer', 'loyalty', 'user', 'tier' ,'current'], baseTier);

  const reservationRequest = store.getIn(['customer', 'reservation_request']);

  const accumulatedPoints = getSTPoints(store);
  return {
    accumulatedPoints,
    advantages : tierList.find((tier)=>tier.get("code") === currentTier),
    loyalty,
    tier: currentTier,
    isLoyaltyReservation : !!reservationRequest.get("loyalty")
  }
};


export default compose(
  connect(
    mapStateToProps,
  ),
  PropertyManager(['tier',  "loyalty","advantages","isLoyaltyReservation", "accumulatedPoints"]),
  withThemeJSS({ styleFile, link: true, displayName: 'STSummaryBanner' }),
  withContent('i18n'),
)(STSummaryBanner);
